import ReplaceThemeApp from "../../templates/replaceTheme.svelte";
import resetTheme from "./resetTheme";
import bulkUpload from "./bulkUpload";

export default function replaceTheme() {
  const themeID = CodeEditor.Main.themeId();
  const themeName = CodeEditor.Main.themeName();
  let app = new ReplaceThemeApp({
    target: document.querySelector(".page-container"),
    props: {
      themeName,
      themeID,
      clearFileTree: resetTheme,
      reloadTree: CodeEditor.Tree.reload,
      bulkUpload,
      destroy() {
        app.$destroy();
        app = null;
      }
    }
  });
}
